import type { ReactNode } from 'react';
import cn from 'classnames';
import IconSidebar from '@creditflowresearch/uilib/Icon/IconSidebar';
import Button from '@creditflowresearch/uilib/Button';
import Flex from '@creditflowresearch/uilib/Flex';
import InfiniteChatHistoryList from './InfiniteChatHistoryList';
import styles from './chatHistoryPanel.module.scss';

interface IChatHistoryPanelProps {
  isCollapsed: boolean,
  onToggle: () => void,
  actions: ReactNode,
}

const ChatHistoryPanel = ({ isCollapsed, onToggle, actions }: IChatHistoryPanelProps) => (
  <Flex
    direction="column"
    className={ cn(styles.panel, { [styles.collapsed]: isCollapsed }) }
    dataTest="askAiChatHistorySidebar"
  >
    <Flex align="center" justify="space-between" className={ styles.header }>
      <h3 className={ styles.heading }>Recent Chats</h3>
      <Button
        variant="text"
        size="S"
        icon={ <IconSidebar /> }
        iconSize={ 16 }
        onClick={ onToggle }
        ariaLabel="Chat history"
        aria-expanded={ !isCollapsed }
        dataTest="aiSidebarHistoryToggle"
      />
    </Flex>
    { isCollapsed && (
      <Flex
        direction="column"
        align="center"
        alignSelf="flex-end"
        gap={ 8 }
        className={ styles.railActions }
        dataTest="aiSidebarRailActions"
      >
        { actions }
      </Flex>
    ) }
    <InfiniteChatHistoryList className={ styles.listArea } dataTest="askAiChatHistoryList" />
  </Flex>
);

export default ChatHistoryPanel;
